(function ($) {
  if($('.Banner-with-image-carusel').length> 0){
  setTimeout(function() {
    $(".Banner-with-image-carusel").addClass('active');
},  200);
if ($(".Banner-with-image-carusel").find(".bottom-content").length > 0) {
  $(".Banner-with-image-carusel").addClass("has-bottom-content");
}
  $(document).ready(function () {
    if ($(".Banner-with-image-carusel  .img-outer").length > 1) {
      var $textSlider = $(".Banner-with-image-carusel .text-content-wrapper");
      var $imgSlider = $(".Banner-with-image-carusel .img-wrapper");
      
      // Initialize text slider
      $textSlider.slick({
        autoplay: false,  // Disable autoplay on text slider, let image slider control it
        dots: true,      // Don't show dots on text slider
        arrows: false,
        infinite: false, 
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1, 
        fade: true, 
        cssEase: "linear",
        appendDots: $('.slider-dots'),
        asNavFor: $imgSlider,  // Sync with image slider
      });
      
      // Initialize image slider
      $imgSlider.slick({
        autoplay: false,    
        dots: false, 
        arrows: false,
        infinite: false, 
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1, 
        fade: true, 
        cssEase: "linear", 
        asNavFor: $textSlider,  // Sync with text slider
      });
    }
  });}
})(jQuery);